import React from 'react';
import PropTypes from 'prop-types';
import { ShowInMikolow } from '../configs/globals';
import LogoSmall from '../images/logo_small.png';

export const Footer = ({ officeFooter, ...props }) => (
	<footer className="footer">
		<div className="footer__container container">
			<div className="footer__contact-data" vocab="http://schema.org/" typeof="Organization">
				<div className="footer__infos">
					<div className="footer__info">
						<div className="footer__info-name" property="name">
							{officeFooter.name || ''}
						</div>
						<div className="footer__info-text">
							{officeFooter.street} {officeFooter.number}{' '}
							{officeFooter.flat ? `m. ${officeFooter.flat}` : ''}
							<br />
							{officeFooter.postCode} {officeFooter.city}
						</div>
					</div>
					{(officeFooter.phone || officeFooter.fax) && (
						<div className="footer__info">
							<div className="footer__info-name">Kontakt</div>
							{officeFooter.phone && (
								<div className="footer__info-text">
									tel.{' '}
									<a
										className="footer__info-link"
										href={`tel:${officeFooter.phone}`}
										property="telephone"
										title={`Zadzwoń do urzędu na numer ${officeFooter.phone}`}
									>
										<span aria-hidden="true">{officeFooter.phone}</span>
									</a>
								</div>
							)}
							{officeFooter.fax && (
								<div className="footer__info-text">
									faks.{' '}
									<a
										className="footer__info-link"
										href={`tel:${officeFooter.fax}`}
										property="faxNumber"
										title="Numer telefonu na fax"
									>
										<span aria-hidden="true">{officeFooter.fax}</span>
									</a>
								</div>
							)}
							{ShowInMikolow && (
								<div className="footer__info-text">
									<a
										className="footer__info-link"
										href="mailto:bom@umradom.pl"
										property="email"
										title="Wyślij email do urzędu"
									>
										<span aria-hidden="true">bom@umradom.pl</span>
									</a>
								</div>
							)}
						</div>
					)}
				</div>
			</div>
			<div className="footer__open-hours">
				<div className="footer__contact-title">
					<i className="far fa-clock footer__contact-title-icon" aria-hidden="true" />{officeFooter.takeOverDocumentPlace}
				</div>
				<div className="footer__oh-days">
					<div className="footer__oh-day">
						<div
							className="footer__oh-hours"
							dangerouslySetInnerHTML={{ __html: officeFooter.officeOpenHours }}
						/>
					</div>
				</div>
			</div>
			<div className="footer__buttons">
				<a
					className="icon-button"
					href={`${officeFooter.www}`}
					target="_blank"
					title="Przejdź do strony głównej urzędu"
				>
					<div className="icon-button__icon" aria-hidden="true">
						{props.applicationImages && (
							<img
								className="icon-button__icon-img"
								src={`data:${props.applicationImages.smallLogoContentType};base64,${props
									.applicationImages.smallLogo}`}
								title="Logo urzędu"
								alt="Małe logo urzędu"
							/>
						)}
					</div>
					<div className="icon-button__text" aria-hidden="true">
						Strona główna Urzędu
					</div>
				</a>
				<a
					className="icon-button"
					href={`${officeFooter.bip}`}
					target="_blank"
					title="Przejdź do Biuletynu Informacji Publicznej"
					aria-label="Link do Biuletynu Informacji Publicznej"
				>
					<div className="icon-button__icon icon-button__icon--with-svg" aria-hidden="true">
						<svg
							className="icon-button__icon-svg"
							width="331.47836"
							height="388.66479"
							viewBox="0 0 536.22711 1237.6193"
							id="svg2"
							space="preserve"
						>
							<defs id="defs4">
								<linearGradient
									x1="384.267"
									y1="618.80798"
									x2="623.04901"
									y2="618.80798"
									id="linearGradient3088"
									gradientUnits="userSpaceOnUse"
									gradientTransform="matrix(3.1826893,0,0,3.1826893,-1334.8767,-1350.6617)"
								>
									<stop
										id="stop9"
										style={{
											stopColor: '#da251d',
											stopOpacity: 1
										}}
										offset="0"
									/>
									<stop
										id="stop11"
										style={{
											stopColor: '#89211b',
											stopOpacity: 1
										}}
										offset="0.50196099"
									/>
								</linearGradient>
							</defs>
							<rect
								className="icon-button__icon-svg-rect"
								width="3486.0752"
								height="1237.6199"
								x="-857.53802"
								y="-0.00064429396"
								id="rect2339"
							/>
							<path
								className="icon-button__icon-svg-path"
								d="m -259.6465,1018.0644 839.22742,0 216.29174,219.5549 0,-704.65061 -1055.5198,0 0,485.09601 6.4e-4,-3e-4 z M 288.91864,151.47532 c -12.40615,0 -22.47017,10.06402 -22.47017,22.47768 l 0,134.05774 c 0,0.0904 0.0255,0.16932 0.0255,0.25939 0.14291,50.62831 41.35396,91.77921 92.03478,91.77921 50.7674,0 92.07234,-41.28998 92.07234,-92.0386 0,-50.77122 -41.30494,-92.05356 -92.07234,-92.05356 -17.22576,0 -33.31225,4.84214 -47.10571,13.10539 l 0,-55.10954 c 0,-12.41366 -10.05274,-22.47768 -22.48522,-22.47768 l 0,-3e-5 z m 69.59108,109.43741 c 25.98152,0 47.09077,21.13557 47.09077,47.09839 0,25.97396 -21.10925,47.08311 -47.09077,47.08311 -25.95517,0 -47.1057,-21.10925 -47.1057,-47.08311 0,-25.96269 21.1506,-47.09839 47.1057,-47.09839 l 0,0 z m 138.30982,-44.78999 c -12.43248,0 -22.48523,10.07907 -22.48523,22.48144 l 0,76.85431 c 0,27.25594 3.83463,65.41063 36.95166,82.0911 11.08658,5.57149 24.60929,1.09777 30.19208,-9.98508 5.56773,-11.10539 1.09777,-24.60178 -9.98884,-30.18453 -3.01506,-1.50755 -12.19938,-6.15796 -12.19938,-41.92143 l 0,-76.85431 c 0,-12.4024 -10.04899,-22.48143 -22.47016,-22.48143 l -1.3e-4,-7e-5 z m 0.0127,-64.55703 c -13.67685,0 -24.7371,11.0678 -24.7371,24.7371 0,13.65428 11.06025,24.70703 24.7371,24.70703 13.63925,0 24.72583,-11.05275 24.72583,-24.70703 0,-13.66933 -11.08658,-24.7371 -24.72583,-24.7371 z m 115.90718,284.87138 0,-49.60571 c 13.79339,8.267 29.87625,13.10163 47.09075,13.10163 50.75625,0 92.04623,-41.28234 92.04623,-92.04624 0,-50.75243 -41.28998,-92.04624 -92.04623,-92.04624 -50.75626,0 -92.0612,41.29381 -92.0612,92.04624 l 0,128.55042 c 0,12.42117 10.06401,22.47016 22.48522,22.47016 12.42118,0 22.48523,-10.04899 22.48523,-22.47016 l 0,-10e-5 z M 659.8302,260.79974 c 25.95518,0 47.09075,21.12052 47.09075,47.08694 0,25.96645 -21.13557,47.08693 -47.09075,47.08693 -25.9815,0 -47.09075,-21.12052 -47.09075,-47.08693 0,-25.96645 21.10925,-47.08694 47.09075,-47.08694 l 0,0 z M -259.64555,0 l 0,45.816404 1055.5198,0 0,-45.816404 -1055.5198,0 z"
								id="path2345"
							/>
						</svg>
					</div>
					<div className="icon-button__text" aria-hidden="true">
						Biuletyn Informacji Publicznej
					</div>
				</a>
			</div>
		</div>
	</footer>
);

Footer.propTypes = {
	name: PropTypes.string,
	street: PropTypes.string,
	number: PropTypes.string,
	flat: PropTypes.string,
	postCode: PropTypes.string,
	city: PropTypes.string,
	phone: PropTypes.string,
	fax: PropTypes.string,
	bip: PropTypes.string,
	www: PropTypes.string,
	officeOpenHours: PropTypes.string,
	takeOverDocumentPlace: PropTypes.string
};

Footer.defaultProps = {
	name: '',
	street: '',
	number: '',
	flat: '',
	postCode: '',
	city: '',
	phone: '',
	fax: '',
	bip: '',
	www: '',
	officeOpenHours: '',
	takeOverDocumentPlace: 'Biuro Obsługi Mieszkańca'
};
